import moment from "moment";
import { TimePicker, DatePicker } from "@mui/x-date-pickers";
import type { Period } from "../types/period";

const TimePickerLocaleText = {
  fieldHoursPlaceholder: () => "시",
  fieldMinutesPlaceholder: () => "분",
  fieldMeridiemPlaceholder: () => "am/pm",
};

const PeriodInput = ({
  period,
  savePeriod,
  inputKey,
  deletePeriod,
}: {
  period: Partial<Period>;
  savePeriod: (period: Partial<Period>) => void;
  inputKey: string;
  deletePeriod: () => void;
}) => {
  return (
    <div className="period-time-delete">
      <div key={inputKey} className="period">
        <DatePicker
          value={
            period.date
              ? typeof period.date === "string"
                ? moment(period.date)
                : period.date
              : undefined
          }
          format="YYYY-MM-DD"
          slotProps={{
            textField: {
              placeholder: `현장실습 날짜`,
              variant: "standard",
            },
          }}
          onChange={(value) => {
            if (value) savePeriod({ ...period, date: value });
          }}
        />
        <TimePicker
          value={
            period.start_time
              ? typeof period.start_time === "string"
                ? moment(period.start_time, "HH:mm")
                : period.start_time
              : undefined
          }
          localeText={TimePickerLocaleText}
          timeSteps={{ minutes: 15 }}
          ampm={false}
          format="HH:mm"
          slotProps={{
            textField: {
              placeholder: `시작 시간 (시계 클릭)`,
              variant: "standard",
            },
          }}
          closeOnSelect={false}
          onChange={(value) => {
            if (value)
              savePeriod({
                ...period,
                start_time: value,
              });
          }}
        />
        <TimePicker
          value={
            period.end_time
              ? typeof period.end_time === "string"
                ? moment(period.end_time, "HH:mm")
                : period.end_time
              : undefined
          }
          localeText={TimePickerLocaleText}
          timeSteps={{ minutes: 15 }}
          ampm={false}
          format="HH:mm"
          slotProps={{
            textField: {
              placeholder: `종료 시간 (시계 클릭)`,
              variant: "standard",
            },
          }}
          closeOnSelect={false}
          onChange={(value) => {
            if (value) {
              savePeriod({
                ...period,
                end_time: value,
              });
            }
          }}
        />
      </div>
      {period.end_time &&
        period.start_time &&
        (period.end_time > period.start_time ? (
          <span className="time">
            {period.end_time.diff(period.start_time) / 1000 / 60}분
          </span>
        ) : (
          <p
            style={{
              color: "var(--red-300)",
              marginTop: "10px",
            }}
          >
            종료 시간이 시작 시간보다 빠릅니다.
          </p>
        ))}
      <button className="period-delete-button" onClick={deletePeriod}>
        ❌
      </button>
    </div>
  );
};

export default PeriodInput;
